/*
 * @Author: yexiu
 * @Date: 2024-12-09 10:58:30
 * @LastEditors: monai
 * @LastEditTime: 2025-07-23 14:24:44
 */
import { getQueryString } from '@activity-business/h5-package-frameworkTool';

const getCountryCode: DevelopToolShare.GetCountryCode = (app, countryCode) => {
    // 未获取到、未使用固定国家码参数 默认 EN
    const code: string = countryCode ? countryCode : (getQueryString('lang') || 'EN').toUpperCase();
    // 需要反转的国家简称
    const rtlCountry: string[] = ['EG', 'XM', 'ME', 'AR'];

    document.body.style.direction = rtlCountry.includes(code) ? 'rtl' : 'initial';
    // 统一添加国家码ID
    document.body.setAttribute('id', code);

    return code;
};

export default getCountryCode;